const carouselItems = [
  {
    title: '今季必追恋爱韩漫TOP10',
    desc: '从青涩校园到甜蜜职场，盘点本季度最值得追的恋爱题材韩漫，每一部都让你心动不已。',
    tag: '编辑精选',
    image: 'https://readdy.ai/api/search-image?query=Soft%20romantic%20illustration%20of%20a%20couple%20under%20cherry%20blossoms%20in%20Korean%20manhwa%20art%20style%2C%20warm%20pink%20and%20cream%20pastel%20tones%2C%20dreamy%20atmosphere%2C%20delicate%20linework%2C%20editorial%20quality%2C%20clean%20composition%2C%20gentle%20lighting&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    title: '奇幻韩漫世界观深度解析',
    desc: '从异世界转生到猎魔冒险，深入探讨当下最热奇幻韩漫的世界观架构与独特魅力。',
    tag: '深度专题',
    image: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20Korean%20manhwa%20illustration%20with%20magical%20elements%2C%20floating%20islands%20and%20ancient%20runes%2C%20warm%20golden%20and%20amber%20color%20palette%2C%20mystical%20atmosphere%2C%20detailed%20artwork%2C%20editorial%20composition&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    title: '悬疑韩漫：烧脑逆转神作',
    desc: '精选五部反转惊人的悬疑韩漫，每一部都能让你看到最后一页仍然震惊不已。',
    tag: '高分推荐',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20Korean%20manhwa%20illustration%20with%20shadowy%20figures%20and%20dramatic%20lighting%2C%20noir%20atmosphere%2C%20deep%20burgundy%20and%20dark%20cream%20tones%2C%20suspenseful%20mood%2C%20cinematic%20composition%2C%20high%20contrast&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    title: '古风韩漫：朝鲜时代美学',
    desc: '穿越回朝鲜时代，感受华丽韩服与宫廷权谋交织的古风韩漫独特美学魅力。',
    tag: '古风精选',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Korean%20historical%20manhwa%20illustration%20with%20hanbok%20clothing%20and%20ancient%20palace%20architecture%2C%20warm%20earthy%20tones%20of%20terracotta%20and%20cream%2C%20elegant%20brushwork%2C%20serene%20yet%20dramatic%20atmosphere&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
  {
    title: '新番速递：本周最新上架',
    desc: '第一时间为你整理本周新上架的韩漫作品，不错过任何一部潜力新作。',
    tag: '每周更新',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20vibrant%20Korean%20manhwa%20illustration%20with%20dynamic%20characters%20and%20colorful%20modern%20setting%2C%20bright%20coral%20and%20cream%20tones%2C%20energetic%20youthful%20vibe%2C%20clean%20composition%2C%20contemporary%20art%20style&width=800&height=500&seq=carousel-05&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            焦点推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            编辑团队精心挑选，每周更新焦点专题，带你发现最值得看的韩漫作品
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-semibold">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}